import { render, staticRenderFns } from "./TemporaryItemPotentialSelectInputWidget.vue?vue&type=template&id=6ef5330c&scoped=true"
import script from "./TemporaryItemPotentialSelectInputWidget.vue?vue&type=script&lang=js"
export * from "./TemporaryItemPotentialSelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef5330c",
  null
  
)

export default component.exports